export const styles = {
  container: {
    backgroundColor: '#f9f9ff',
    height: 'calc(100vh - 72px)',
    padding: '32px 35px 20px 40px',
  },
  back: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    fontWeight: 700,
    color: '#4F5B94',
    cursor: 'pointer',
    gap: '10px',
  },
  titleWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    gap: '16px',
  },
  titleIconButton: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '24px',
  },
  titleIcon: {
    padding: '22px 10px',
  },
  description: {
    width: '100%',
    maxWidth: '800px',
    color: '#011533',
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 400,
    marginBottom: '32px',
  },
  cardWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > div': {
      marginRight: '8px',
      marginBottom: '8px',
    },
  },
  card: {
    boxShadow: '0px 2px 14px 0px rgba(39, 55, 84, 0.08)',
    borderRadius: '8px',
    background: '#FFFFFF',
    padding: '10px',
    width: '182px',
  },
  cardTitle: {
    fontSize: '15px',
    fontWeight: 700,
    marginBottom: '6px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  cardDescription: {
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: '20px',
    marginBottom: '10px',
  },
  date: {
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  button: {
    minWidth: '150px',
    paddingTop: '4px',
    paddingBottom: '4px',
    borderRadius: '12px',
    height: '40px',
    backgroundColor: '#ee4360',
    color: '#FFFFFF',
    textTransform: 'none',
    border: '1px solid #ee4360',
    padding: '7px 20px',
    alignSelf: 'center',
    '&:hover': {
      backgroundColor: '#ee4360',
    },
  },
  actionWrapper: {
    marginTop: '6px',
    marginRight: '6px',
  },
}
